export default __webpack_public_path__ + "static/media/sikom-white.55544549.png";